/**
 * src/db/promos.db.js
 *
 * Datos cargados en tiempo de ejecución desde /data/promos.json.
 * main.js llama a setPromos() antes de renderizar la app.
 */

export const promosData = {
    section:   {},
    tags:      [],
    tagColors: {},
    items:     []
}

export function setPromos(data) {
    Object.assign(promosData, data)
}

export const PROMO_TAGS = ['Todos', 'Descuento', 'Novedad', '2×1', 'Lanzamiento', 'Gratis']

export const TAG_COLORS = {
    'Descuento':   { bg: '#dcfce7', color: '#166534' },
    'Novedad':     { bg: '#dbeafe', color: '#1e40af' },
    '2×1':         { bg: '#fef9c3', color: '#854d0e' },
    'Lanzamiento': { bg: '#f3e8ff', color: '#6b21a8' },
    'Gratis':      { bg: '#ffe4e6', color: '#9f1239' }
}
